export default __webpack_public_path__ + "static/media/pic1.8ad45e2e.jpg";